// extracted by mini-css-extract-plugin
export var deliveryRow = "_pb-a";
export var fixedHeight = "_pb-4";
export var freightLogo = "_pb-9";
export var fullWidth = "_pb-3";
export var priceColumn = "_pb-5";
export var radioSelected = "_pb-7";
export var radioUnselected = "_pb-6";
export var selectedOption = "_pb-2";
export var selectedOptionContainer = "_pb-1";
export var selection = "_pb-0";
export var tallSkeletonText = "_pb-8";